import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit'
import CityPage from './../../../../Containers/City/Page'
import { getCityLink } from 'Utils/Link'
import { ACTION_EDIT } from 'constants.js'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'
import { styles } from './style'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import SubmitButton from 'Components/Form/SubmitButton'
import Roster from './Roster/index'
import List from './List/index'
import injectStyles from 'react-jss'
import { convertQueryStringToObj, urlRemove } from '../../../../Utils/URL'

const Spy = props => {
  const { nav, cityId, cityName, classes, history, match } = props
  const [viewType, setViewType] = useState('list')

  const changeTab = tabName => {
    // Remove url search keys because they are conflicting
    // between roster and list view
    const keys = convertQueryStringToObj(window.location.search)
    for (const key in keys) {
      urlRemove(key)
    }
    setViewType(tabName)
  }

  return (
    <CityPage
      active={nav}
      cityId={cityId}
      history={history}
      match={match}
      cityName={cityName}
      breadcrumbs={[{ label: 'Spies' }]}
    >
      <Link to={getCityLink(cityId, ACTION_EDIT)} className="link-edit-main">
        <StyledIconButton>
          <EditIcon />
        </StyledIconButton>
      </Link>
      <div className={classes.spyWrapper}>
        <div className={classes.controls}>
          <ButtonGroup disableElevation color="primary">
            <SubmitButton
              value="List"
              variant={viewType === 'list' ? 'contained' : 'outlined'}
              onClick={() => changeTab('list')}
            />
            <SubmitButton
              value="Roster"
              variant={viewType === 'roster' ? 'contained' : 'outlined'}
              onClick={() => changeTab('roster')}
            />
          </ButtonGroup>
        </div>
        {viewType === 'roster' && <Roster {...props} />}
        {viewType === 'list' && <List {...props} />}
      </div>
    </CityPage>
  )
}

export default injectStyles(styles)(Spy)
